import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListBullet = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M3 12h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 18h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 6h.01" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 12h13" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 18h13" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 6h13" })
	]
});
export default SvgListBullet;
